/**
 * Centralized API configuration.
 * Both production and QA base URLs are committed; the app uses production by default.
 * Switch to QA by changing API_ENV to 'qa' below.
 */

export type ApiEnvironment = 'production' | 'qa';

/** Base URLs (both committed). Production is used by default; QA when API_ENV = 'qa'. */
export const API_BASE_URLS: Record<ApiEnvironment, string> = {
  production: 'http://sqldb.catchus.in:9927',
  qa: 'http://sqldb.catchus.in:9927',
};


// https://sqldb.catchus.in
/**
 * Active environment. Change ONLY this line to switch:
 *   API_ENV = 'production'  → uses production URL
 *   API_ENV = 'qa'          → uses QA URL
 * (Do not comment out URLs; both are always defined above.)
 */
export const API_ENV: ApiEnvironment = 'production';

/**
 * Returns the API base URL for the current environment.
 * Optional: localStorage key 'baseUrl' overrides the configured URL (e.g. for dev/custom endpoints).
 */
export function getApiBaseUrl(): string {
  const normalize = (url: string) => url.trim().replace(/\/+$/, '');
  if (typeof window !== 'undefined' && window.localStorage) {
    const override = localStorage.getItem('baseUrl');
    if (override) return normalize(override);
  }
  return normalize(API_BASE_URLS[API_ENV]);
}
